import { TDropdown } from "../../shared/modal";

export enum VendorType {
    PRIME_VENDOR = 1,
    SUB_VENDOR = 2,
}

export const VendorTypeLabel: Record<VendorType, string> = {
    [VendorType.PRIME_VENDOR]: "Prime Vendor",
    [VendorType.SUB_VENDOR]: "Sub Vendor",
};

export const VendorTypeOptions = Object.values(VendorType)
    .filter(v => typeof v === "number")
    .map(v => ({
        id: v,
        name: VendorTypeLabel[v as VendorType]
    }));

export type TVendorCompanyRecord = {
    id?: number;
    name: string;
    countryId: number;
    state: TDropdown;
    stateId: number;
    city: TDropdown;
    cityId: number;
    address: string;
    vendorType: VendorType;
    status: boolean;
    websiteUrl: string;
    faxNo?: string;
    majorTech?: string;
    phoneNo: string;
    alternatePhoneNo?: string;
    feid?: string;
}

export const EmptyVendorCompanyRecord: TVendorCompanyRecord = {
    name: '',
    countryId: 0,
    state: { id: 0, name: '' },
    stateId: 0,
    city: { id: 0, name: '' },
    cityId: 0,
    address: '',
    phoneNo: '',
    vendorType: VendorType.SUB_VENDOR,
    status: true,
    websiteUrl: '',
}

export type TVendorCompany = {
    id: number;
    name: string;
    cityId: number;
    cityName: string;
    stateId: number;
    stateName: string;
    countryId: number;
    countryName: string;
    address: string;
    vendorType: VendorType;
    status: boolean;
    websiteUrl: string;
    faxNo?: string;
    majorTech?: string;
    phoneNo: string;
    alternatePhoneNo?: string;
    feid?: string;
}